// extracted by mini-css-extract-plugin
export default {"footer":"UdSDcvP7IL_ZIWxbAJdw","small":"GhgXX5LCYl_B3qymvG60","footerBorder":"VqcNBUVouBgQP7lLRV_n","actions":"ZOvqNSeY6kHok3dAxkxi","actionsContainer":"KATsS7bWchNNWAx7WZe2"};